export enum UserProfilEnum {
    Supervisor = 'Supervisor',
    Expert = 'Expert',
    Administrator = 'Administrator',
    Operator = 'Operator',
    Client = 'Client'
}